import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import SectionHeading from "./SectionHeading";
import LangLink from "../shared/LangLink";
import { StaggerGroup, StaggerItem } from "../shared/Reveal";
import { TRUST_SAFETY } from "../../data/homeContent";

export default function TrustSafety() {
  return (
    <section className="bg-surface py-20 md:py-28 lg:py-36" data-testid="trust-safety">
      <div className="container-psv">
        <SectionHeading eyebrow={TRUST_SAFETY.eyebrow} heading={TRUST_SAFETY.heading} intro={TRUST_SAFETY.intro} />

        <StaggerGroup className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {TRUST_SAFETY.items.map((item) => {
            const Icon = Icons[item.icon] || Icons.Circle;
            return (
              <StaggerItem key={item.title}>
                <div className="h-full bg-background border border-border rounded-lg p-7 hover:border-accent transition-colors duration-300" data-testid={`trust-item-${item.icon}`}>
                  <div className="w-12 h-12 rounded-full border border-accent/40 flex items-center justify-center mb-5">
                    <Icon className="w-5 h-5 text-accent" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-sans font-medium text-[15px] text-primary leading-snug">{item.title}</h3>
                </div>
              </StaggerItem>
            );
          })}
        </StaggerGroup>

        <LangLink to={TRUST_SAFETY.linkTo} className="mt-10 inline-flex items-center gap-2 text-accent font-medium font-sans hover:gap-3 transition-all" data-testid="trust-safety-link">
          {TRUST_SAFETY.link} <ArrowUpRight className="w-4 h-4" />
        </LangLink>
      </div>
    </section>
  );
}
